import { neverHere } from "../tsHelpers";

export const asArray = () => [
  LocationImageType.Hero,
  LocationImageType.LtoMain,
  LocationImageType.LtoSecondary,
  LocationImageType.ContentHeader,
  LocationImageType.TrustHeader,
  LocationImageType.Footer,
  LocationImageType.ReviewFooter,
];

export const toFriendlyName = (type: LocationImageType) => {
  switch (type) {
    case LocationImageType.Hero:
      return "Hero";
    case LocationImageType.LtoMain:
      return "LTO Primary";
    case LocationImageType.LtoSecondary:
      return "LTO Secondary";
    case LocationImageType.ContentHeader:
      return "Content Header";
    case LocationImageType.TrustHeader:
      return "Trust Header";
    case LocationImageType.Footer:
      return "Footer";
    case LocationImageType.ReviewFooter:
      return "Review Footer";
    default:
      neverHere(type);
  }
};